import { isValidCellphoneInput } from '@solfacil/frontend-utils/cellphone';
import { z } from 'zod';

import { nomeCompletoSchema } from './nomeCompletoSchema';

const celularSchema = z
  .string()
  .trim()
  .refine(
    (value) => value === '' || isValidCellphoneInput(value),
    { message: 'Celular inválido' },
  );

export const associateFormSchema = z.object({
  celular: celularSchema,
  nomeCompleto: nomeCompletoSchema,
  userId: z.number({ required_error: 'Usuário vinculado é obrigatório' }).nullable().refine(
    (v) => v !== null,
    { message: 'Usuário vinculado é obrigatório' },
  ),
});

// eslint-disable-next-line perfectionist/sort-modules
export type AssociateFormData = z.infer<typeof associateFormSchema>;
